import { render, staticRenderFns } from "./VerooLogo.vue?vue&type=template&id=a205ecec&"
import script from "./VerooLogo.vue?vue&type=script&lang=js&"
export * from "./VerooLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports